import s from './Nice.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faStickyNote } from '@fortawesome/free-solid-svg-icons';
import SubHeader from '../../components/SubHeader/SubHeader';
import { Aside } from '../../components/Aside/Aside';
import { Helmet } from "react-helmet";

const blogs = [
  {
    id: 9,
    title: 'ケアンズ旅行中の観光プランは個人で手配？それともガイド付きツアー？',
    date: '2019年11月21日',
    category: 'ツアーをお得に探す',
    comment: '',
    img: 'https://dev.mightyaussie.com/wp-content/uploads/2019/11/tourguide-howto-select_main-1-960x530.jpg',
    body: 'オーストラリアの世界遺産を含めたおすすめ観光スポット情報を探していませんか？定番どころから少し穴場的なスポットまでオーストラリアの観光スポット26選をご覧ください。オーストラリアへ旅行したくなりますよ！旅行の際はぜひジェイさんツアーまでご相談ください。',
    link: '/blog/nice/tourguide-howto-select',
    magazine: false,
    sale: true,
    world: false,
    info: false,
  },
  {
    id: 10,
    title: 'お得にケアンズ旅行を準備する6つの手順',
    date: '2019年11月3日',
    category: 'ツアーをお得に探す',
    comment: '',
    img: 'https://dev.mightyaussie.com/wp-content/uploads/2019/11/cairns-otoku-travel_main-960x530.jpg',
    body: 'オーストラリアの世界遺産（観光名所）は全部で20箇所あります。オーストラリアの広い国土は日本の約20倍もあります！観光名所をどこにしようか、と決めかねてしまうのではないでしょうか？マップで全体のいちを把握しながら、どのような世界遺産がどこにあるのかを把握していきましょう。',
    link: '/blog/nice/otoku-cairns-travel',
    magazine: false,
    sale: true,
    world: false,
    info: false,
  },
  {
    id: 11,
    title: 'ケアンズの最安値ツアーを探すときに気をつけること',
    date: '2019年7月9日',
    category: 'ツアーをお得に探す',
    comment: '',
    img: 'https://dev.mightyaussie.com/wp-content/uploads/2019/07/blog_001@2x-960x530.png',
    body: 'こんにちは！　ジェイさんツアーです。 7月に入り、日本の方が暑い日が出てきているのではないでしょうか？ ケアンズは、朝晩は少しひんやりしてとても過ごしやすい時期',
    link: '/blog/nice/tour-search-kokoroe',
    magazine: false,
    sale: true,
    world: false,
    info: false,
  },
];
const breadcrumbs = [
  { label: 'ホーム ', link: '/' },
  { label: 'ジェイさんブログ', link: '/blog' },
  { label: 'カテゴリー: ツアーをお得に探す' },
];


const Nice = () => {
  return (
    <>
          <Helmet>
        <title>ツアーをお得に探す – ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】</title>
        <meta property="og:title" content="ツアーをお得に探す – ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】" />
        <meta property="og:url" content={`${process.env.REACT_APP_URL}/category/blog/nice`} />
        <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:type" content="article" />
      </Helmet>
    <div className={s.root}>
    <SubHeader
      title="カテゴリー: ツアーをお得に探す"
      breadcrumbs={breadcrumbs}
    />
      <div className={s.flex}>
      <div className={s.blogContainer}>
    {blogs.map((blog) => (
      <a
        key={blog.id}
        href={blog.link}
        className={s.cardLinkWrapper}
        aria-label={blog.title}
      >
        <div className={s.card}>
          <div className={s.cardContent}>
            <h3 className={s.cardTitle}>{blog.title}</h3>
              <div className={s.cardMeta}>
                <span className={s.cardMetaItem}>
                <i className="fa fa-calendar"></i>{blog.date}
                </span>
                <span className={s.cardMetaItem}>
                <i className="fa fa-user"></i>ジェイさんツアー
                </span>
                {blog.magazine && (
                  <span className={s.cardMetaItem}>
                  <i className="fa fa-pencil"></i>ジェイさんマガジン
                  </span>
                )}
                {blog.sale && (
                  <span className={s.cardMetaItem}>
                  <i className="fa fa-pencil"></i>ツアーをお得に探す
                  </span>
                )}
                {blog.world && (
                  <span className={s.cardMetaItem}>
                  <i className="fa fa-pencil"></i>世界遺産の観光スポット
                  </span>
                )}
                {blog.info && (
                  <span className={s.cardMetaItem}>
                  <i className="fa fa-pencil"></i>ケアンズで快適に過ごすお得情報
                  </span>
                )}
              </div>
            <img src={blog.img} alt={blog.title} className={s.cardImage} />
            <p className={s.cardBody}>{blog.body.slice(0, 100)}...</p>
            <div className={s.center}><a className={s.button} href={blog.link}>続きを見る<i class="atbtn__icon atbtn__icon--right fa fa-long-arrow-right"></i></a></div>
          </div>
        </div>
      </a>
    ))}
  </div>
      <Aside/>
      </div>
    </div>
    </>
  );
}

export default Nice;
